// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; // Make sure styles are imported

// const root = ReactDOM.createRoot(document.getElementById('root'));
const root = ReactDOM.createRoot(document.getElementById('ketoneaidlanding'));

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);